/**
 * Background-scroll lock for modals.
 *
 * The app shell (`.dashboard-layout`) fills the viewport and never scrolls —
 * `.dashboard-main` is the scroll area — so setting `overflow: hidden` on
 * <body> does nothing. Lock the scroller itself instead, falling back to the
 * document element for any screen rendered outside the dashboard chrome
 * (login, for example).
 *
 * Returns the unlock function, so an effect can use it directly as cleanup:
 *
 *   useEffect(() => (isOpen ? lockAppScroll() : undefined), [isOpen]);
 */
export function lockAppScroll(): () => void {
  const target =
    document.querySelector<HTMLElement>('.dashboard-main') ?? document.documentElement;
  const previous = target.style.overflow;
  target.style.overflow = 'hidden';
  return () => {
    target.style.overflow = previous;
  };
}
